"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_present_1 = require("./is-present");
/**
 * Returns the given value if present, otherwise undefined.
 *
 * @Param {string | any | any[]} value = The value to test presence on.
 *
 * @Example
 *   presence({})
 *   //=> undefined
 *
 *   presence({ fruit: 'banana' })
 *   //=> { fruit: 'banana' }
 *
 *   presence([])
 *   //=> undefined
 *
 *   presence(['banana'])
 *   //=> ['banana']
 *
 *   presence('')
 *   //=> undefined
 *
 *   presence('banana')
 *   //=> 'banana'
 *
 *   presence(1)
 *   //=> 1
 *
 *   presence(NaN)
 *   //=> undefined
 *
 *   presence(true)
 *   //=> true
 *
 *   presence(false)
 *   //=> undefined
 */
function presence(value) {
    if (is_present_1.isPresent(value)) {
        return value;
    }
    return undefined;
}
exports.presence = presence;
//# sourceMappingURL=presence.js.map